export const localStorageUpdate = <T extends object>(
  storageName: string,
  value: T,
) => {
  const rawItem = localStorage.getItem(storageName);
  if (!rawItem) return;

  let item = JSON.parse(rawItem) as T;
  item = { ...item, ...value };

  localStorage.setItem(storageName, JSON.stringify(item));
};

export const localStorageSet = <T>(storageName: string, value: T) => {
  localStorage.setItem(storageName, JSON.stringify(value));
};

export const localStorageGet = (storageName: string) => {
  let _value = localStorage.getItem(storageName);

  if (!_value) return;

  try {
    return JSON.parse(_value);
  } catch (e) {
    return _value;
  }
};

export const localStorageRemove = (storageName: string) => {
  localStorage.removeItem(storageName);
};

export const localStorageClear = () => {
  localStorage.clear();
};
